import { CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableCellProps, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { motion } from "framer-motion";
import { LoadingDots } from "../loadingDot";

const MotionTableRow = motion(TableRow);

interface IProps {
    head: {
        label: string,
        placement?: TableCellProps["align"]
    }[],
    body: {
        label: string,
        placement?: TableCellProps["align"],
        customized?: JSX.Element
    }[][],
    onRowClick?: (rowIndex: number, row: string[]) => void,
    loading?: boolean
}

export const TableComponent = ({
    head,
    body,
    loading,
    onRowClick
}: IProps) => {
    return (
        <TableContainer
            component={Paper}
            sx={{
                maxHeight: "600px",
                overflow: 'auto'
            }}
        >
            <Table sx={{
                minWidth: 700
            }} aria-label="customized table">
                <TableHead sx={{
                    borderBottom: "2px solid black"
                }}>
                    <TableRow>
                        {head.map((item, index) => <TableCell key={'head-' + index} align={item.placement}>{item.label}</TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!loading && body.map((row, index) => (
                        <MotionTableRow
                            key={'row-' + index}
                            variants={{
                                hidden: { opacity: 0, y: 500 },
                                visible: { opacity: 1, y: 0 },
                            }}
                            initial="hidden"
                            animate="visible"
                            transition={{
                                duration: 0.4,
                                delay: index * 0.1,
                            }}
                            onClick={() => {
                                if (onRowClick) {
                                    onRowClick(index, row.map((item) => item.label))
                                }
                            }}
                            sx={{
                                ... (onRowClick && {
                                    cursor: "pointer",
                                    ":hover": {
                                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                                    }
                                })
                            }}
                        >
                            {row.map((item, i) => {
                                return (
                                    <TableCell align={item.placement} sx={{
                                        ... (index > 0 && {
                                            borderTop: "1px solid rgba(0, 0, 0, 0.4)"
                                        })
                                    }}>{item.customized ? item.customized : item.label}</TableCell>
                                )
                            })}
                        </MotionTableRow>
                    ))}
                </TableBody>
            </Table>
            {loading && <Grid
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <LoadingDots style={{ margin: "2rem 0px" }} />
            </Grid>}

            {(!loading && body.length === 0) && <Grid
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                margin={"2rem 0px"}
            >
                <Typography sx={{ opacity: .5 }}>Nenhum registro encontrado.</Typography>
            </Grid>}
        </TableContainer>
    )
}